module.exports = __webpack_public_path__ + "img/蒙版组 185.677cdbb6.svg";